<template>
  <div>
    <h5 class="auth-logo">
      <div class="banner-container">
        <div class="bbi-banner"></div>
      </div>
    </h5>

    <b-container fluid>
      <b-row align-h="start" style="padding-left: 10px; padding-right: 10px">
        <b-col sm="12" style="margin-top: -10px">
          <b-form-group
            label-for="SPG"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
          >
            <b-form-input
              style="font-size: 15px; font-weight: 700"
              id="SPG"
              v-model="nikSpg"
              placeholder="Masukkan Nik"
            >
            </b-form-input>
            <span
              id="warning-spg"
              class="display-hidden text-small text-danger"
            >
              Required
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="12" style="margin-top: -10px">
          <b-form-group
            label-for="Birthday "
            label-cols-sm="3"
            label-align-sm="left"
            description="Format: YYYY-MM-DD (e.g., 1991-10-08)"
            label-size="sm"
          >
          <b-form-input
              style="font-size: 15px; font-weight: 700"
              id="Birthday"
              v-model="birthday"
              placeholder="Birthday">
            <!-- <VueDatePicker
              style="border: 1px solid #ccc; border-radius: 4px; width: 100%"
              v-model="birthday"
              format="DD MMMM YYYY"
              no-header
              placeholder="Select Birthday"
            > -->
              <template #input-icon>
                <b-icon
                  scale="1"
                  style="color: black"
                  icon="calendar3"
                ></b-icon>
              </template>
          </b-form-input>
            <!-- </VueDatePicker> -->
            <span
              id="warning-birthday"
              class="display-hidden text-small text-danger"
            >
              Required
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="padding-left: 10px; padding-right: 10px">
        <b-col sm="12" class="text-right">
          <b-button variant="primary" @click="addNewAudit"> Mulai </b-button>
        </b-col>
      </b-row>

      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_CGC } from "../../../../api/api-paths";
export default {
  components: {
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      formName: "Audit",
      roles_list: [],
      isLoading: false,
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      nikSpg: null,
      birthday: null,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    setData() {
      let data = JSON.parse(localStorage.getItem("spg_audit"));
      if (data) {
        this.$router.push({ name: "CGCAuditAgree" });
      }
      // let roles = this.userData.roles;
      // if (roles.length > 0) {
      //   for (let data in roles) {
      //     if (roles[data].app == "CGC" || roles[data].app == "Default") {
      //       let lower = roles[data].role_list.map((string) => {
      //         return string.toLowerCase();
      //       });
      //       this.roles_list = lower;
      //     }
      //   }
      // }
    },

    LoadData() {},

    addNewAudit() {
      // this.birthday = "1987-10-08";
      this.isLoading = true;
      fnPOST(APIPATH_CGC.getSpgAssign, {
        nik_spg: this.nikSpg,
        birthday: this.birthday,
      })
        .then((rsp) => {
          this.isLoading = false;
          this.showNotification({
            type: "success",
            message: " Login successfully",
          });

          if (rsp.data.payload) {
            let data = JSON.stringify(rsp.data.payload);
            localStorage.setItem("spg_audit", data);
            this.$router.push({
              name: "CGCAuditAgree",
              params: { data: data },
            });
          }
          // this.$router.push({ name: "CGCAuditList" });
        })
        .catch((err) => {
          this.isLoading = false;
          this.showNotification({
            type: "error",
            message: "Failed to login",
          });
        });
    },
  },
  created() {
    this.setData();
  },
};
</script>
<style src="../CGC.scss" lang="scss" scoped />
